import { createApp } from "vue";
import { createPinia } from "pinia";
import store from "@two-ui/store";
import App from "./App.vue";
import router from "./router";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from "@fortawesome/vue-fontawesome";
import "@two-ui/icons";
import clickOutside from "@wegift/two-components/src/directives/ClickOutside";

const pinia = createPinia();
const app = createApp(App);
app.directive("click-outside", clickOutside);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("font-awesome-layers", FontAwesomeLayers);
app.use(router);

app.use(pinia);

store.populateInitialState();

app.mount("#app");
